import { colors, elevation } from '@atlaskit/theme';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { redirect } from '../../../facade/window';
import { AnalyticsConsumerProps, withAnalytics } from '../../../hoc/withAnalytics';
import { isNewTabClick } from '../../../util/event';
import { cardContainerStyle, iconContainerStyle } from '../style';

export interface Link {
  icon: typeof React.Component;
  message: FormattedMessage.MessageDescriptor;
  name: string;
  url: string;
}

type Props = Link & {
  fullScreen?: boolean;
};

const IconContainer = styled.div`
  ${iconContainerStyle};

  ${elevation.e200};
  transition: box-shadow 0.25s;

  &:hover {
    ${elevation.e400};
  }
`;

const Container = styled.a`
  ${cardContainerStyle};

  &:hover {
    > ${IconContainer} {
      ${elevation.e400};
    }
  }
`;

const Description = styled.div`
  font-weight: 600;
  font-size: 12px;
  color: ${colors.N800};
`;

class LinkCard extends React.Component<Props & AnalyticsConsumerProps> {
  render() {
    const { icon, message, url } = this.props;
    const Icon = icon;
    return (
      <Container href={url} onClick={this.onClick}>
        <IconContainer>
          <Icon size="xlarge" />
        </IconContainer>
        <Description>
          <FormattedMessage {...message} />
        </Description>
      </Container>
    );
  }

  private onClick = async (event: React.MouseEvent<HTMLElement>) => {
    const { fullScreen, name, url } = this.props;
    const isOpeningInNewTab = isNewTabClick(event);
    if (!isOpeningInNewTab) {
      event.preventDefault();
    }
    await this.props.analytics.ui('linkCard', 'clicked', {
      fullScreen,
      name,
      url,
    });
    if (!isOpeningInNewTab) {
      redirect(url);
    }
  };
}

export default withAnalytics(LinkCard);
